import { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Search } from "lucide-react";
import { updateData } from "../../../../redux/dataSlice";

const CylinderPredictionSearch = () => {
  const dispatch = useDispatch();

  // ------------------------------------------------------------------
  // Redux data
  // ------------------------------------------------------------------
  const copyData = useSelector((state) => state.data.copyData);
  const isFiltered = useSelector((state) => state.isTableFilter.isFiltered);
  const filteredData = useSelector((state) => state.isTableFilter.filteredData);
  const baseData = isFiltered ? filteredData : copyData;

  // ------------------------------------------------------------------
  // Local UI state
  // ------------------------------------------------------------------
  const [mode, setMode] = useState("cylinder"); // "station" | "cylinder"
  const [query, setQuery] = useState("");

  // ------------------------------------------------------------------
  // Build filtered list whenever mode, query, or data changes
  // ------------------------------------------------------------------
  const results = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return baseData;

    return baseData.filter((row) => {
      if (mode === "station") {
        // station search: name or id
        return (
          (row.station_name && row.station_name.toLowerCase().includes(q)) ||
          (row.station_id &&
            row.station_id.toString().toLowerCase().includes(q))
        );
      }

      if (mode === "cylinder") {
        return (
          row.operationalCylinder &&
          row.operationalCylinder.serialNumber.toLowerCase().includes(q)
        );
      }

      return false;
    });
  }, [mode, query]);

  // Push results to Redux whenever they change
  useMemo(() => {
    dispatch(updateData(results));
  }, [results, dispatch]);

  return (
    <div className="flex items-center mr-1">
      {/* dropdown: Station / Cylinder */}

      {/* search box */}
      <div className="relative">
        <input
          type="text"
          placeholder={
            mode === "station" ? "Search name/id" : "Search Cylinder"
          }
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="fuseInput"
        />
        <Search size={16} color="#021472" className="absolute right-2 top-2" />
      </div>
      <select
        value={mode}
        onChange={(e) => setMode(e.target.value)}
        className=" py-[6px] max-lg:text-xs text-sm bg-gray-300 text-dark-blue border-2 rounded-br rounded-tr border-l-0 border-dark-blue focus-visible:outline-0 cursor-pointer hover:bg-gray-200"
      >
        <option value="station">Station</option>
        <option value="cylinder">Cylinder</option>
      </select>
    </div>
  );
};

export default CylinderPredictionSearch;
